"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.APPLY_COUPON_CARD_STATIC = exports.APPLY_COUPON_CARD_DEFAULTS = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _CouponIcon = _interopRequireWildcard(require("./CouponIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const APPLY_COUPON_CARD_DEFAULTS = exports.APPLY_COUPON_CARD_DEFAULTS = {
  title: 'Apply Coupon “VisitAHC”',
  subtitle: 'Extra discount up to 20% ',
  buttonText: 'Apply',
  iconSize: 58,
  iconGap: 12,
  borderRadius: 16,
  fontFamily: 'Inter, sans-serif',
  colors: {
    gradientStart: '#f5f2ff',
    gradientEnd: '#ffffff',
    border: '#f2f2f3',
    title: '#000000',
    subtitle: '#1eb865',
    button: 'var(--primary-button, #714fff)',
    arrow: '#000000'
  },
  iconColors: _CouponIcon.COUPON_ICON_DEFAULT_COLORS
};
const APPLY_COUPON_CARD_STATIC = exports.APPLY_COUPON_CARD_STATIC = {
  title: 'Apply Coupon',
  subtitle: '',
  showButton: false,
  showArrow: true
};
const ArrowRightIcon = _ref => {
  let {
    size = 20,
    color
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    style: {
      display: 'block'
    },
    "aria-hidden": "true",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M9 19L16 12L9 5",
      stroke: color,
      strokeWidth: "1.7",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
const ApplyCouponCard = _ref2 => {
  let {
    title = APPLY_COUPON_CARD_DEFAULTS.title,
    subtitle = APPLY_COUPON_CARD_DEFAULTS.subtitle,
    buttonText = APPLY_COUPON_CARD_DEFAULTS.buttonText,
    icon,
    iconSize = APPLY_COUPON_CARD_DEFAULTS.iconSize,
    iconColors,
    iconGap = APPLY_COUPON_CARD_DEFAULTS.iconGap,
    colors: colorsProp,
    borderRadius = APPLY_COUPON_CARD_DEFAULTS.borderRadius,
    fontFamily = APPLY_COUPON_CARD_DEFAULTS.fontFamily,
    showButton = true,
    showArrow = false,
    arrowSize = 20,
    loading = false,
    onApply,
    sx = {},
    ...rest
  } = _ref2;
  const colors = {
    ...APPLY_COUPON_CARD_DEFAULTS.colors,
    ...colorsProp
  };
  const handleApply = loading ? undefined : onApply;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
    onClick: handleApply,
    sx: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      pl: '10px',
      pr: '16px',
      py: '12px',
      borderRadius: `${borderRadius}px`,
      border: `1px solid ${colors.border}`,
      background: `linear-gradient(to right, ${colors.gradientStart} 3%, ${colors.gradientEnd})`,
      overflow: 'hidden',
      cursor: handleApply ? 'pointer' : 'default',
      fontFamily,
      ...sx
    },
    ...rest,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
      sx: {
        display: 'flex',
        flex: '1 0 0',
        minWidth: 0,
        alignItems: 'center',
        gap: `${iconGap}px`
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
        sx: {
          flexShrink: 0,
          width: iconSize,
          height: iconSize,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        },
        children: icon || /*#__PURE__*/(0, _jsxRuntime.jsx)(_CouponIcon.default, {
          size: iconSize,
          colors: iconColors
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
        sx: {
          display: 'flex',
          flex: '1 0 0',
          minWidth: 0,
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '4px'
        },
        children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
          sx: {
            fontFamily,
            fontWeight: 600,
            fontSize: '14px',
            lineHeight: 1.4,
            letterSpacing: '0.25px',
            color: colors.title,
            m: 0
          },
          children: title
        }), subtitle && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
          sx: {
            fontFamily,
            fontWeight: 600,
            fontSize: '12px',
            lineHeight: 1.5,
            letterSpacing: '-0.2px',
            color: colors.subtitle,
            m: 0
          },
          children: subtitle
        })]
      })]
    }), showArrow && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
      sx: {
        flexShrink: 0,
        width: arrowSize,
        height: arrowSize,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ArrowRightIcon, {
        size: arrowSize,
        color: colors.arrow
      })
    }), showButton && buttonText && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.ButtonBase, {
      disableRipple: true,
      disabled: loading,
      onClick: e => {
        if (onApply && !loading) {
          e.stopPropagation();
          onApply(e);
        }
      },
      sx: {
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '4px'
      },
      children: loading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.CircularProgress, {
        size: 14,
        sx: {
          color: colors.button
        }
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
        sx: {
          fontFamily,
          fontWeight: 600,
          fontSize: '12px',
          lineHeight: 1.4,
          color: colors.button,
          whiteSpace: 'nowrap',
          m: 0
        },
        children: buttonText
      })
    })]
  });
};
var _default = exports.default = ApplyCouponCard;